module.exports = __webpack_public_path__ + "static/media/pumpkin-people.68387db6.png";